import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { useLoginOrSignupHeader } from './hooks/useLoginOrSignupHeader';

export const LoginOrSignupHeader: React.FC = () => {
	const {
		data: { step, title, subtitle },
	} = useLoginOrSignupHeader();

	return (
		<>
			<Text variant="heading" size="x-large" fontWeight="bold" as="h1" className="mb-6" data-qa={`${step}-step-title`}>
				{title}
			</Text>
			{subtitle && (
				<Text size="large" data-qa={`${step}-step-subtitle`}>
					{subtitle}
				</Text>
			)}
		</>
	);
};
